import { render, staticRenderFns } from "./ToySelectWithRents.vue?vue&type=template&id=250d25bf&"
import script from "./ToySelectWithRents.vue?vue&type=script&lang=js&"
export * from "./ToySelectWithRents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports